<template>
  <div class="page__agency_plan a-page">
    <div style="background-color:white; padding:10px; border-radius: 4px; overflow: hidden">
      <div style="padding-left: 5px">
        <!--        <p class="text-primary" style="font-weight: bold; font-size: 20px">Kế Hoạch Agency</p>-->
        <el-tabs v-model="tab">
          <el-tab-pane label="Lập kế hoạch" name="plan"></el-tab-pane>
          <el-tab-pane label="Kết quả thực hiện" name="result"></el-tab-pane>
        </el-tabs>
      </div>

      <div :style="tab === 'plan' ? 'display: block' : 'display: none'">
        <el-row style="margin-top: 20px; padding-left: 5px">
          <el-col :sm="12">
            <div style="display: inline-block; margin-right: 10px">
              <strong style="font-size: 13px">{{ $t('select.shop') }}</strong><br>
              <el-select size="small" :placeholder="$t('select.shop')" v-model="shopee_shop.selected"
                         :disabled="loading.get_metrics" filterable>
                <el-option-group :label="$t('shop.added')">
                  <el-option v-for="item in shopee_shop.list.filter(i => !i.is_sub_account)" :key="item.username"
                             :label="`${item.username} ${item.name}`" :value="item._id">
                    <div>
                      <table style="width:100%;">
                        <tbody>
                        <tr>
                          <td style="width:40px;">
                            <img style="width:28px; height:28px; border-radius: 50vh;"
                                 :src="logo_channel(item.channel)"
                                 alt="image">
                          </td>
                          <td style="padding-left:10px;">
                            {{ item.username }}
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </el-option>
                </el-option-group>
                <el-option-group :label="$t('shop.managed')">
                  <el-option v-for="item in shopee_shop.list.filter(i => i.is_sub_account)" :key="item.username"
                             :label="`${item.username} ${item.name}`" :value="item._id">
                    <div>
                      <table style="width:100%;">
                        <tbody>
                        <tr>
                          <td style="width:40px;">
                            <img style="width:28px; height:28px; border-radius: 50vh;"
                                 :src="logo_channel(item.channel)"
                                 alt="image">
                          </td>
                          <td style="padding-left:10px;">
                            {{ item.username }}
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </el-option>
                </el-option-group>
              </el-select>
            </div>
            <div style="display: inline-block; margin-right: 10px">
            </div>
          </el-col>
          <el-col :sm="12" class="text-right">
            <strong style="font-size: 13px">&nbsp;</strong><br>
            <el-button size="small" type="primary" icon="el-icon-s-order" @click="m__show_agency_file_dialog">
              Danh sách file kế hoạch
            </el-button>
            <el-button type="primary" size="small" icon="el-icon-plus" @click="m__show_select_product_dialog">
              Chọn sản phẩm lập kế hoạch
            </el-button>
          </el-col>
        </el-row>

        <el-row style="margin-top: 60px; padding-left: 5px">
          <el-row>
            <el-col :sm="12">
              <strong class="text-primary" style="font-size: 13px">Danh sách sản phẩm
              </strong>
            </el-col>
            <el-col :sm="12" class="text-right">
              <el-button size="mini" @click="m__calculate_target_gmv"> Tính doanh thu mong muốn</el-button>
              &nbsp;&nbsp;
              <el-dropdown @command="m__handle_command">
                <el-button size="mini" icon="el-icon-caret-bottom">Xử lý hàng loạt
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="1">Cài đặt giá bán sản phẩm ngày thường</el-dropdown-item>
                  <el-dropdown-item command="2">Cài đặt giá bán sản phẩm ngày sale</el-dropdown-item>
                  <el-dropdown-item command="3">Xóa sản phẩm</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
          </el-row>

          <el-table :data="product_selected_list" style="margin-top: 10px" v-loading="loading.select_product">
            <el-table-column width="40px">
              <template slot="header" slot-scope="scope">
                <el-checkbox size="mini" :indeterminate="indeterminate" v-model="is_selected_all"
                             @change="m__select_all"></el-checkbox>
              </template>
              <template slot-scope="scope">
                <el-checkbox size="mini" v-model="scope.row.selected" @change="m__indeterminate"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column :label="$t('base.product')" show-tooltip-when-overflow width="300px">
              <template slot-scope="scope">
                <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="logo"
                     style="width:35px; height: 35px;"> &nbsp;&nbsp;&nbsp; {{ scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column label="Giá SP" prop="price" width="130px" sortable="custom">
              <template slot-scope="scope">{{ scope.row.price | currency }} ₫</template>
            </el-table-column>
            <el-table-column label="Dữ liệu tham khảo" align="center">
              <el-table-column label="Tổng GMV 3 tháng qua" width="150px">
                <template slot-scope="scope">
                  {{ scope.row.gmv | currency }}
                </template>
              </el-table-column>
              <el-table-column label="Trung bình CR 3 tháng qua" width="150px">
                <template slot-scope="scope">
                  {{ scope.row.cr }}%
                </template>
              </el-table-column>
              <el-table-column label="Tổng GMV Ads 3 tháng qua" width="150px">
                <template slot-scope="scope">
                  {{ scope.row.gmv_ads | currency }}
                </template>
              </el-table-column>
              <el-table-column label="Doanh thu seeding" width="150px">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.gmv_seeding" placeholder="doanh thu seeding">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px" class="text-danger">{{ scope.row.gmv_seeding | currency }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="Vụ mùa" width="150px">
                <template slot-scope="scope">
                  <el-select size="mini" v-model="scope.row.season" value="">
                    <el-option label="Đang vào mùa" value="in"></el-option>
                    <el-option label="Chuẩn bị vào mùa" value="prepare"></el-option>
                    <el-option label="Tháng cuối mùa" value="last"></el-option>
                    <el-option label="Chưa vào mùa" value="not"></el-option>
                  </el-select>
                  <br>
                  <strong style="font-size: 12px" class="text-danger">&nbsp;</strong>
                </template>
              </el-table-column>
              <el-table-column label="Volume thị trường" width="150px">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.volume_erp" placeholder="volume thị trường">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px" class="text-danger">{{ scope.row.volume_erp | currency }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="Giá bán ngày thường" width="150px">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.normal_price"
                            placeholder="giá bán ngày thường">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px" class="text-danger">{{ scope.row.normal_price | currency }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="Giá bán ngày sale" width="150px">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.sale_price" placeholder="giá bán ngày sale">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px" class="text-danger">{{ scope.row.sale_price | currency }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="Doanh thu mong muốn" width="150px">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.expected_gmv"
                            placeholder="doanh thu mong muốn">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px" class="text-danger">{{ scope.row.expected_gmv | currency }}</strong>
                </template>
              </el-table-column>
            </el-table-column>
            <!--            <el-table-column label="Dữ liệu tính toán">-->
            <!--            </el-table-column>-->
          </el-table>
        </el-row>

        <el-row style="margin-top: 60px; padding-left: 5px">
          <el-row>
            <el-col :sm="10">
              <strong class="text-primary" style="font-size: 13px">Kế hoạch chi tiết
              </strong>
            </el-col>
          </el-row>

          <el-row style="margin-top: 20px">
            <el-col :sm="4">
              <strong class="strong-label">{{ $t('base.expected_cir') }}</strong>
              <el-input size="mini" placeholder="cir mong muốn" v-model="expected_cir"></el-input>
            </el-col>
            <el-col :sm="20" class="text-right">
              <strong class="strong-label">&nbsp;</strong><br>
              <el-button size="mini" icon="el-icon-files" @click="m__show_agency_filename_dialog">
                Lưu file kế hoạch
              </el-button>
              <el-button type="primary" size="mini" icon="el-icon-plus" @click="generate_plan_order">
                Tính toán kế hoạch
              </el-button>
            </el-col>
          </el-row>

          <el-table :data="plan_order_product_list" style="margin-top: 10px">
            <!--            <el-table-column width="40px">-->
            <!--              <template slot-scope="scope">-->
            <!--                <el-checkbox size="mini" v-model="scope.row.selected"></el-checkbox>-->
            <!--              </template>-->
            <!--            </el-table-column>-->
            <el-table-column :label="$t('base.product')" show-tooltip-when-overflow width="300px">
              <template slot-scope="scope">
                <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="logo"
                     style="width:35px; height: 35px;"> &nbsp;&nbsp;&nbsp; {{ scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column label="Kế hoạch tháng" align="center">
              <el-table-column label="Tổng GMV" width="120px" prop="plan_gmv">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_gmv">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px" class="text-danger">{{ scope.row.plan_gmv | currency }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="Tổng Traffic" width="120px" prop="plan_traffic">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_traffic">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px" class="text-danger">{{ scope.row.plan_traffic | currency }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="Tổng Đơn hàng" width="120px" prop="plan_order">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_order">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px" class="text-danger">{{ scope.row.plan_order | currency }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="Tổng Đơn hàng max" width="120px" prop="plan_order_max">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_order_max">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px" class="text-danger">{{ scope.row.plan_order_max | currency }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="Tổng GMV Ads" width="120px" prop="plan_gmv_ads">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_gmv_ads">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px" class="text-danger">{{ scope.row.plan_gmv_ads | currency }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="Tổng Click Ads" width="120px" prop="plan_click_ads">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_click_ads">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px" class="text-danger">{{ scope.row.plan_click_ads | currency }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="Tổng Đơn hàng Ads" width="120px" prop="plan_order_ads">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_order_ads">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px" class="text-danger">{{ scope.row.plan_order_ads | currency }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="Tổng Đơn hàng Ads max" width="120px" prop="plan_order_ads_max">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_order_ads_max">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px"
                          class="text-danger">{{ scope.row.plan_order_ads_max | currency }}</strong>
                </template>
              </el-table-column>
              <el-table-column :label="$t('metric.ads_expense')" width="120px" prop="plan_cost_ads">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_cost_ads">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px"
                          class="text-danger">{{ scope.row.plan_cost_ads | currency }}</strong>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="Kế hoạch ngày sale" align="center">
              <el-table-column label="GMV Ngày sale" width="120px" prop="plan_gmv_sale">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_gmv_sale">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px" class="text-danger">{{ scope.row.plan_gmv_sale | currency }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="GMV Ads Ngày sale" width="120px" prop="plan_gmv_ads_sale">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_gmv_ads_sale">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px"
                          class="text-danger">{{ scope.row.plan_gmv_ads_sale | currency }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="Traffic Ngày sale" width="120px" prop="plan_traffic_sale">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_traffic_sale">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px"
                          class="text-danger">{{ scope.row.plan_traffic_sale | currency }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="Click Ads Ngày sale" width="120px" prop="plan_click_ads_sale">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_click_ads_sale">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px"
                          class="text-danger">{{ scope.row.plan_click_ads_sale | currency }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="Chi phí Ads Ngày sale" width="120px" prop="plan_cost_ads_sale">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_cost_ads_sale">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px"
                          class="text-danger">{{ scope.row.plan_cost_ads_sale | currency }}</strong>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="Kế hoạch ngày thường" align="center">
              <el-table-column label="GMV Ngày thường" width="120px" prop="plan_gmv_day">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_gmv_day">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px" class="text-danger">{{ scope.row.plan_gmv_day | currency }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="GMV Ads Ngày thường" width="120px" prop="plan_gmv_ads_day">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_gmv_ads_day">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px" class="text-danger">{{
                      scope.row.plan_gmv_ads_day | currency
                    }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="Traffic Ngày thường" width="120px" prop="plan_traffic_day">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_traffic_day">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px" class="text-danger">{{
                      scope.row.plan_traffic_day | currency
                    }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="Click Ads Ngày thường" width="120px" prop="plan_click_ads_day">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_click_ads_day">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px"
                          class="text-danger">{{ scope.row.plan_click_ads_day | currency }}</strong>
                </template>
              </el-table-column>
              <el-table-column label="Chi phí Ads Ngày thường" width="120px" prop="plan_cost_ads_day">
                <template slot-scope="scope">
                  <el-input type="number" size="mini" v-model="scope.row.plan_cost_ads_day">
                  </el-input>
                  <br>
                  <strong style="font-size: 12px"
                          class="text-danger">{{ scope.row.plan_cost_ads_day | currency }}</strong>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </el-row>
      </div>
      <div :style="tab === 'result' ? 'display: block' : 'display: none'">
        <ResultOrderComponent></ResultOrderComponent>
      </div>
    </div>

    <el-dialog width="1300px" :close-on-click-modal="false" :visible.sync="show_dialog.select_product"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <el-row type="margin-top: 10px">
          <el-col :sm="12">
            <p v-if="loading.get_product"><span class="el-icon-loading"></span>
              <strong style="font-size: 18px" class="text-danger">
                {{ $t('base.loading_products') }}</strong></p>
            <p v-else><strong style="font-size: 18px">{{ $t('select.products') }}
              <a href="javascript:void(0)" @click="m__get_product(null, false)">({{ $t('base.update') }})</a></strong></p>
          </el-col>
          <el-col :sm="12" class="text-right">
            <el-input type="text" size="mini" v-model="product_filter.keyword" style="width: 300px"
                      :placeholder="$t('input.placeholder')"></el-input>
          </el-col>
        </el-row>

        <el-table :data="c__product_display_list" @sort-change="m__product_sort_change">
          <el-table-column width="40px" fixed="left">
            <!--            <template slot="header" slot-scope="scope">-->
            <!--              <el-checkbox size="mini" :indeterminate="indeterminate" v-model="is_selected_all"-->
            <!--                           @change="m__select_all" :disabled="product_selected_list.length >= 10"></el-checkbox>-->
            <!--            </template>-->
            <template slot-scope="scope">
              <!--              <el-checkbox size="mini" v-model="scope.row.selected" @change="m__indeterminate "-->
              <!--                           :disabled="product_selected_list.length >= 10"></el-checkbox>-->
              <el-checkbox size="mini" v-model="scope.row.selected"
                           :disabled="product_selected_list.length >= 10"></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.product')" show-tooltip-when-overflow>
            <template slot-scope="scope">
              <img :src="SHOPEE_IMAGE(scope.row.images.split(',')[0])" alt="logo"
                   style="width:35px; height: 35px;"> &nbsp;&nbsp;&nbsp; {{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('center.add_to_cart_units_30_days')" prop="add_to_cart_units" width="160px"
                           sortable="custom">
          </el-table-column>
          <el-table-column :label="$t('base.monthly_sales')" prop="monthly_sales" width="130px" sortable="custom">
          </el-table-column>
          <el-table-column :label="$t('base.price')" prop="price" width="130px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.price | currency }} ₫</template>
          </el-table-column>
          <el-table-column :label="$t('base.sales')" prop="revenue" width="130px" sortable="custom">
            <template slot-scope="scope">{{ scope.row.revenue | currency }} ₫</template>
          </el-table-column>
          <el-table-column :label="$t('base.stock')" prop="stock" width="130px" sortable="custom">
          </el-table-column>
        </el-table>
        <el-pagination :current-page.sync="product_filter.current_page" :page-size="product_filter.page_size"
                       layout="prev, pager, next, total" :total="c__product_filter_list.length"/>

        <el-row style="margin-top: 15px">
          <el-col :sm="12">
            &nbsp;
          </el-col>
          <el-col :sm="12" class="text-right">
            <small>{{ $t('base.selected') }} <span style="color: orangered">{{ product_list.filter(i => i.selected).length }}</span> /
              <span
                style="color: orangered">{{ product_list.length }}</span> {{ $t('base.products') }}</small>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <el-button size="mini" type="primary" icon="el-icon-check" @click="m__confirm_select_product"
                       :disabled="!product_list.filter(i => i.selected).length">{{ $t('base.confirm') }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <el-dialog width="1000px" :close-on-click-modal="false" :visible.sync="show_dialog.agency_file"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <strong style="font-size: 13px">Danh sách file kế hoạch</strong>
        <el-table
          :data="agency_files.filter(i => $store.state.userInfo.username ==='vuducminhdev07' ? true : i.mipeeUserId === $store.state.userInfo.username)">
          <el-table-column :label="$t('base.filename')" prop="filename"></el-table-column>
          <el-table-column :label="$t('base.status')" prop="status">
            <template slot-scope="scope">
              <strong v-if="selected_file && selected_file.id === scope.row.id" class="text-success">
                Đang sử dụng</strong>
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.month')" prop="month" width="100px">
            <template slot-scope="scope">
              {{ `${scope.row.month + 1}/${scope.row.year}` }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.shop')" width="150px">
            <template slot-scope="scope">
              {{ m__get_shop_name(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column :label="$t('base.action')" width="200px">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="m__use_agency_file(scope.row)" :loading="scope.row.loading">
                <strong class="text-info">{{ $t('base.use_file') }}</strong></el-button>
              <el-button type="text" size="mini" @click="m__delete_agency_file(scope.row)">
                <strong class="text-danger">Xoá</strong></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog width="400px" :close-on-click-modal="false" :visible.sync="show_dialog.create_agency_filename"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <p class="text-title">Tháng:</p>


        <p class="text-title">{{ $t('base.filename') }}</p>
        <el-input v-model="filename" size="mini" placeholder="Nhập tên file..."></el-input>

        <br><br>
        <div class="text-right">
          <el-button size="mini" type="primary" icon="el-icon-check" @click="m__save_agency_file"
                     :loading="loading.save_file">Lưu file dữ liệu
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="500px" :close-on-click-modal="false" :visible.sync="show_dialog.update_discount_value"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <strong style="font-size: 13px">Chỉnh sửa giá bán ngày thường</strong>

        <div style="margin-top: 30px">
          <strong class="strong-label">Phần trăm giảm giá ngày thường</strong>
          <el-input size="mini" placeholder="nhập % giảm giá ngày thường" v-model="discount_value"></el-input>
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" @click="m__confirm_update_discount_value">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog width="500px" :close-on-click-modal="false" :visible.sync="show_dialog.update_discount_sale_value"
               custom-class="no-body">
      <div slot="title" style="padding:10px">
        <strong style="font-size: 13px">Chỉnh sửa giá bán ngày sale</strong>

        <div style="margin-top: 30px">
          <strong class="strong-label">Phần trăm giảm giá ngày sale</strong>
          <el-input size="mini" placeholder="nhập % giảm giá ngày thường" v-model="discount_sale_value"></el-input>
        </div>

        <div style="margin-top: 30px" class="text-right">
          <el-button type="primary" size="mini" icon="el-icon-check" @click="m__confirm_update_discount_sale_value">
            {{ $t('base.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//import dayjs from 'dayjs'
import {drop as _drop, orderBy as _orderBy, take as _take} from 'lodash'
import {map_campaign_data, map_graph_response} from '../../addon/ads_function'
import ResultOrderComponent from './result_order'
import {get_shop_mixins} from '../../mixins/get_shop';

export default {

  mixins: [get_shop_mixins],

  components: {
    ResultOrderComponent
  },

  data() {
    return {
      seller: null,
      tab: 'plan',
      loading: {
        generate_data: false,
        save_file: false,
        calculate: false,
        get_metrics: false,
        get_product: false,
        select_product: false
      },
      show_dialog: {
        select_product: false,
        agency_file: false,
        create_agency_filename: false,
        update_discount_value: false,
        update_discount_sale_value: false
      },
      is_destroyed: false,
      product_list: [],
      product_selected_list: [],
      product_sort_option: {
        order: null,
        prop: null
      },
      product_filter: {
        page_size: 10,
        current_page: 0,
        keyword: '',
        available: false
      },
      indeterminate: false,
      is_selected_all: false,

      plan_order_product_list: [],

      send_request_list: [],
      agency_files: [],
      selected_file: {},

      filename: '',

      date: new Date(),

      expected_cir: 20,

      discount_value: null,
      discount_sale_value: null
    }
  },

  async beforeMount() {
    await this.m__get_shopee_shop()
    await this.m__get_agency_file()
  },

  async beforeDestroy() {
    this.is_destroyed = true
  },

  watch: {
    'shopee_shop.selected': function () {
      this.m__initial_view()
    }
  },

  computed: {
    c__product_filter_list() {
      let result = this.product_list.filter(i => !this.product_selected_list.some(ii => ii.itemid === i.itemid))
      if (this.product_sort_option.order) {
        this.product_sort_option.order === 'ascending' && (result = _orderBy(result, [this.product_sort_option.prop], ['asc']))
        this.product_sort_option.order === 'descending' && (result = _orderBy(result, [this.product_sort_option.prop], ['desc']))
      }

      const words = this.remove_unicode(this.product_filter.keyword)
      return result.filter(item => this.remove_unicode(item.name).includes(words))
    },

    c__product_display_list() {
      const limit = this.product_filter.page_size
      const skip = limit * (this.product_filter.current_page - 1)
      return _take(_drop(this.c__product_filter_list, skip), limit)
    }
  },

  methods: {
    m__show_update_discount_value_dialog() {
      this.show_dialog.update_discount_value = true
    },

    m__show_update_discount_sale_value_dialog() {
      this.show_dialog.update_discount_sale_value = true
    },

    m__confirm_update_discount_value() {
      if (!this.discount_value) {
        this.ntf_w('Vui lòng nhập đầy đủ thông tin')
      }

      for (const item of this.product_selected_list) {
        const value = Math.floor(item.price * +this.discount_value / 100)
        item.normal_price = item.price - value
      }
      this.show_dialog.update_discount_value = false
    },

    m__confirm_update_discount_sale_value() {
      if (!this.discount_sale_value) {
        this.ntf_w('Vui lòng nhập đầy đủ thông tin')
      }

      for (const item of this.product_selected_list) {
        const value = Math.floor(item.price * +this.discount_sale_value / 100)
        item.sale_price = item.price - value
      }
      this.show_dialog.update_discount_sale_value = false
    },

    m__handle_command(command) {
      if (command === '1') this.m__show_update_discount_value_dialog()
      if (command === '2') this.m__show_update_discount_sale_value_dialog()
      if (command === '3') this.m__remove_selected_product()
    },

    m__remove_selected_product() {
      this.product_selected_list = this.product_selected_list.filter(i => !i.selected)
    },

    m__calculate_target_gmv() {
      if (!this.product_selected_list.filter(i => i.selected).length) {
        this.ntf_w('Vui lòng chọn sản phẩm cần tính toán')
        return
      }

      for (const item of this.product_selected_list.filter(i => i.selected)) {
        let target_gmv = 0

        if (item.volume) {
          let percent
          if (item.volume > 1000000000) {
            percent = 15
            if (+item.gmv_seeding) {
              if (+item.gmv_seeding > 200000000) {
                percent += 6
              } else {
                percent += 3
              }
            }

            if (item.season === 'in') {
              percent += 6
            }
            if (item.season === 'prepare') {
              percent += 3
            }
            if (item.season === 'last') {
              percent -= 2
            }
            if (item.season === 'not') {
              percent -= 3
            }
          } else {
            percent = 10
            if (+item.gmv_seeding) {
              if (+item.gmv_seeding > 200000000) {
                percent += 5
              } else {
                percent += 2
              }
            }

            if (item.season === 'in') {
              percent += 5
            }
            if (item.season === 'prepare') {
              percent += 2
            }
            if (item.season === 'last') {
              percent -= 1
            }
            if (item.season === 'not') {
              percent -= 3
            }
          }

          const value = Math.floor(item.max_gmv * percent / 100)
          target_gmv = item.max_gmv + value
        } else {
          const value = Math.floor(item.max_gmv * 20 / 100)
          target_gmv = item.max_gmv + value
        }

        item.expected_gmv = Math.floor(target_gmv)
      }
    },

    m__show_agency_file_dialog() {
      this.show_dialog.agency_file = true
    },

    m__get_shop_name(file) {
      const shop_found = this.shopee_shop.list.find(i => i._id === file.shopId)
      return shop_found ? shop_found.username : ''
    },

    async m__save_agency_file() {
      if (!this.plan_order_product_list.length) {
        return
      }

      if (!this.filename) {
        this.ntf_w(this.$t('required.filename'))
      }

      this.loading.save_file = true
      try {
        await this.$http.post(this.API.URL_API_SRV_1 + '/agency_file/order', {
          mipeeUserId: this.$store.state.userInfo.username,
          shopId: this.shopee_shop.selected,
          filename: this.filename,
          month: this.dayjs(this.date).month(),
          year: this.dayjs(this.date).year(),
          data: JSON.stringify(this.plan_order_product_list)
        }, this.cf())
        await this.m__get_agency_file()

        this.show_dialog.create_agency_filename = false
        this.ntf_s('Tạo file thành công')
      } catch (e) {
        this.ntf_w(e)
      } finally {
        this.loading.save_file = false
      }
    },

    m__show_agency_filename_dialog() {
      if (!this.plan_order_product_list.length) {
        return
      }

      this.filename = `Kế hoạch theo đơn Tháng ${this.dayjs(this.date).month() + 1}/${this.dayjs().year()} - ${this.dayjs().format('DDMMHHmm')}`
      this.show_dialog.create_agency_filename = true
    },

    async m__get_agency_file() {
      // const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file/all', {
      // const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file', {
      const mipeeUserIds = [this.$store.state.userInfo.username, ...this.send_request_list.filter(i => i.status === 'accepted').map(i => i.request_user.username)].join(',')
      const resp = await this.$http.get(this.API.URL_API_SRV_1 + '/agency_file/list/order', {
        ...this.cf(),
        params: {
          mipeeUserId: this.$store.state.userInfo.username,
          mipeeUserIds
        }
      })
      for (const item of resp.body) {
        item.loading = false
      }
      this.agency_files = resp.body.filter(i => this.$store.state.userInfo.username === 'vuducminhdev07' ? true : this.shopee_shop.list.some(ii => ii._id === i.shopId))

      // console.log(this.agency_files)
      // if (this.agency_files.length) {
      //   const first = _orderBy(this.agency_files, ['year', 'month', 'createdAt'], ['desc', 'desc', 'desc'])[0]
      //   await this.m__use_agency_file(first)
      //   this.ntf_s('Đã sử dụng file kế hoạch: ' + first.filename)
      // }
    },

    m__use_agency_file(file) {
      file.loading = true
      try {
        if (this.shopee_shop.list.find(i => i._id === file.shopId)) {
          this.selected_file = file
          this.product_selected_list = JSON.parse(file.data)
          this.plan_order_product_list = JSON.parse(file.data)

          this.show_dialog.agency_file = false
        }
      } catch (e) {
        console.error(e)
      } finally {
        file.loading = false
      }
    },

    async m__delete_agency_file(file) {
      try {
        await this.$confirm('Bạn có muốn xoá file agency này không?', this.$t('base.attention'), {
          type: 'warning',
          confirmButtonText: this.$t('base.confirm'),
          cancelButtonText: this.$t('base.cancel')
        })

        await this.$http.delete(this.API.URL_API_SRV_1 + '/agency_file', {
          ...this.cf(),
          params: {
            fileId: file.id,
            mipeeUserId: this.$store.state.userInfo.username
          }
        })
        await this.m__get_agency_file()
        this.ntf_s('Xoá file thành công')
      } catch (e) {
      }
    },

    async generate_plan_order() {
      if (!this.product_selected_list.length) {
        this.ntf_w('Vui lòng chọn sản phẩm để làm kế hoạch')
        return
      }

      if (this.product_selected_list.some(i => !i.expected_gmv)) {
        this.ntf_w('Vui lòng nhập đầy đủ doanh thu mong muốn cho từng sản phẩm để lập kế hoạch')
        return
      }

      this.plan_order_product_list = []

      // console.log(this.product_selected_list)
      for (const item of this.product_selected_list) {
        const data = {
          ...item,
          plan_gmv: 0,
          plan_traffic: 0,
          plan_order: 0,
          plan_order_max: 0,
          plan_gmv_ads: 0,
          plan_click_ads: 0,
          plan_order_ads: 0,
          plan_order_ads_max: 0,
          plan_cost_ads: 0,
          plan_gmv_sale: 0,
          plan_gmv_ads_sale: 0,
          plan_traffic_sale: 0,
          plan_click_ads_sale: 0,
          plan_cost_ads_sale: 0,
          plan_gmv_day: 0,
          plan_gmv_ads_day: 0,
          plan_traffic_day: 0,
          plan_click_ads_day: 0,
          plan_cost_ads_day: 0
        }

        data.plan_gmv = item.expected_gmv
        data.plan_order = Math.floor(data.plan_gmv / (item.normal_price || item.price))
        data.plan_order_max = Math.floor(data.plan_gmv / (item.sale_price || item.price))
        data.plan_traffic = item.cr ? Math.floor(data.plan_order / item.cr * 100) : 0

        let po_70_value = Math.floor(data.plan_gmv * 30 / 100)
        data.plan_gmv_ads = data.plan_gmv - po_70_value
        data.plan_order_ads = Math.floor(data.plan_gmv_ads / (item.normal_price || item.price))
        data.plan_order_ads_max = Math.floor(data.plan_gmv_ads / (item.sale_price || item.price))
        data.plan_click_ads = item.cr ? Math.floor(data.plan_order / item.cr * 100) : 0
        let cla_70_value = Math.floor(data.plan_click_ads * 30 / 100)
        data.plan_click_ads -= cla_70_value
        data.plan_cost_ads = Math.floor(data.plan_gmv_ads * +this.expected_cir / 100)

        if (data.plan_gmv_ads > 60000000) {
          data.plan_gmv_sale = Math.floor(data.plan_gmv * 20 / 100)
          data.plan_gmv_ads_sale = Math.floor(data.plan_gmv_ads * 20 / 100)
          data.plan_traffic_sale = Math.floor(data.plan_traffic * 20 / 100)
          data.plan_click_ads_sale = Math.floor(data.plan_click_ads * 20 / 100)
          data.plan_cost_ads_sale = Math.floor(data.plan_gmv_ads_sale * +this.expected_cir / 100)
        } else {
          data.plan_gmv_sale = Math.floor(data.plan_gmv * 7 / 100)
          data.plan_gmv_ads_sale = Math.floor(data.plan_gmv_ads * 7 / 100)
          data.plan_traffic_sale = Math.floor(data.plan_traffic * 7 / 100)
          data.plan_click_ads_sale = Math.floor(data.plan_click_ads * 7 / 100)
          data.plan_cost_ads_sale = Math.floor(data.plan_gmv_ads_sale * +this.expected_cir / 100)
        }

        data.plan_gmv_day = Math.floor(data.plan_gmv * 3 / 100)
        data.plan_gmv_ads_day = Math.floor(data.plan_gmv_ads * 3 / 100)
        data.plan_traffic_day = Math.floor(data.plan_traffic * 3 / 100)
        data.plan_click_ads_day = Math.floor(data.plan_click_ads * 3 / 100)
        data.plan_cost_ads_day = Math.floor(data.plan_gmv_ads_day * +this.expected_cir / 100)

        this.plan_order_product_list.push(data)
      }
    },

    async m__confirm_select_product() {
      this.loading.select_product = true

      for (const product of this.product_list.filter(i => i.selected)) {
        if (this.product_selected_list.some(i => i.itemid === product.itemid)) continue

        const data = {
          ...product,
          selected: false,
          gmv: 0,
          cr: 0,
          gmv_ads: 0,
          gmv_seeding: null,
          season: '',
          volume_erp: null,
          normal_price: null,
          sale_price: null,
          expected_gmv: null,
          max_gmv: 0,
          max_gmv_ads: 0,
          max_traffic: 0,
          max_click_ads: 0,
          max_cr: 0,
          avg_gmv: 0,
          avg_gmv_ads: 0,
          avg_traffic: 0,
          avg_click_ads: 0,
          avg_cr: 0
        }

        this.product_selected_list.push(data)
      }

      // console.log(this.product_selected_list)
      this.show_dialog.select_product = false

      for (const item of this.product_selected_list) {
        try {
          let gmv = 0, cr = 0, placed_buyers = 0, uv = 0, gmv_ads = 0, click_ads = 0, cost_ads = 0, order_ads = 0,
            date = this.dayjs().subtract(1, 'month')
          for (let i = 0; i < 3; i++) {
            const start_time = date.clone().startOf('month').unix()
            const end_time = date.clone().endOf('month').add(1, 'second').unix()
            const get_product_performance_response = await this.seller.get_product_performance_v3(1, 20, start_time, end_time, 'month', item.name)
            if (get_product_performance_response && get_product_performance_response.data && get_product_performance_response.data.result && get_product_performance_response.data.result.items) {
              // console.log(get_product_performance_response.data.result.items)
              const found = get_product_performance_response.data.result.items.find(i => i.id = item.itemid)
              if (found) {
                gmv += +found.placed_sales
                placed_buyers += +found.placed_buyers
                uv += +found.uv

                if (+found.placed_sales > item.max_gmv) item.max_gmv = +found.placed_sales
              }
            }
          }
          cr = uv ? +(placed_buyers / uv * 100).toFixed(2) : 0

          for (let i = 0; i < 3; i++) {
            const start_time = date.clone().startOf('month').unix()
            const end_time = date.clone().endOf('month').unix()

            const limit = 50, offset = 0, state = 'all',
              filter = {
                campaign_type: 'product_homepage',
                search_term: item.itemid.toString(),
                state: state
              }
            let campaign_response = await this.seller.marketing_pas_get_campaigns(start_time, end_time, offset, limit, filter)
            campaign_response = map_campaign_data(campaign_response, true)
            // console.log('campaign_response', campaign_response)

            if (campaign_response && campaign_response.data && campaign_response.data.campaign_ads_list) {
              const [gmv_ads_value, click_ads_value, cost_ads_value, order_ads_value] = campaign_response.data.campaign_ads_list.reduce((t, i) => {
                t[0] += Number(i.report.broad_gmv.value)
                t[1] += Number(i.report.click.value)
                t[2] += Number(i.report.cost.value)
                t[3] += Number(i.report.broad_order.value)
                return t
              }, [0, 0, 0, 0])

              gmv_ads += gmv_ads_value
              click_ads += click_ads_value
              cost_ads += cost_ads_value
              order_ads += order_ads_value

              if (gmv_ads_value > item.max_gmv_ads) item.max_gmv_ads = gmv_ads_value
              if (click_ads_value > item.max_gmv_ads) item.max_click_ads = click_ads_value
            }

            // const search_response = await this.seller.marketing_get_time_graph('search_product', start_time, end_time, {item_id: item.itemid})
            // const search_metrics = map_graph_response(search_response.data.report_aggregate)
            // if (search_metrics && +search_metrics.broad_gmv) {
            //   gmv_ads += +search_metrics.broad_gmv
            //   click_ads += +search_metrics.click
            //   cost_ads += +search_metrics.cost
            //   order_ads += +search_metrics.broad_order
            // }
            //
            // const targeting_response = await this.seller.marketing_get_time_graph('targeting', start_time, end_time, {item_id: item.itemid})
            // const targeting_metrics = map_graph_response(targeting_response.data.report_aggregate)
            // if (targeting_metrics && +targeting_metrics.broad_gmv) {
            //   gmv_ads += +targeting_metrics.broad_gmv
            //   click_ads += +targeting_metrics.click
            //   cost_ads += +targeting_metrics.cost
            //   order_ads += +targeting_metrics.broad_order
            // }
            //
            // if ((+search_metrics.broad_gmv + +targeting_metrics.broad_gmv) > item.max_gmv_ads) item.max_gmv_ads = (+search_metrics.broad_gmv + +targeting_metrics.broad_gmv)
            // if ((+search_metrics.click + +targeting_metrics.click) > item.max_click_ads) item.max_click_ads = (+search_metrics.click + +targeting_metrics.click)
          }
          // console.log(gmv_ads)

          item.gmv = gmv
          item.cr = cr
          item.gmv_ads = gmv_ads
        } catch (e) {
          console.error(e)
        }
      }

      this.ntf_s('Lấy dữ liệu thành công')
      this.loading.select_product = false
    },

    async m__initial_view() {
      let items = this.shopee_shop.list.filter(e => e._id === this.shopee_shop.selected)
      if (!this.check_role(items[0], 'marketing', 'flash_sale')) {
        return
      }

      try {
        if (this.shopee_shop.selected.length > 6) {
          if (items.length > 0) {
            this.selected_shop = items[0]
            let item = items[0]
            this.shop = item
            this.seller = await this.init_seller(item)

            if (!await this.check_shop(this.seller)) {
              this.shopee_shop.selected = ''
              return
            }

            await Promise.all([
              this.m__get_product(null, true)
            ])

            this.ntf_s(`${this.$t('shop.connected_to')}: ${this.shop.username}`)
          }
        }
      } catch (e) {
        console.log(e)
        this.ntf_w(`${this.$t('shop.connect_shop_error')}: ${this.shop.username}`)
      } finally {
      }
    },

    async m__get_product(seller = null, performance = false) {
      if (!seller || !seller.username) seller = this.seller

      try {
        this.loading.get_product = true
        this.product_list = []
        this.product_selected_list = []

        let offset = 0, limit = 50
        let product_response = await seller.flash_sale_get_product(offset, limit)
        while (product_response.data.item_list && product_response.data.item_list.length) {

          product_response.data.item_list.forEach(i => {
            i.selected = false
            i.checked = false
            i.limit = 0
            i.limit_value = 100
            i.enable = false
            i.error_message = ''
            i.revenue = i.price * i.sold
            i.add_to_cart_units = 0
            i.created = false
          })
          this.product_list.push(...product_response.data.item_list)

          offset += limit
          product_response = await seller.flash_sale_get_product(offset, limit)
        }

        // this.m__get_product_not_created(seller)
        //   .catch(console.error)

        if (performance) {
          this.is_destroyed = true
          this.is_destroyed = false
          this.m__get_product_performance(seller)
            .catch(console.error)
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.loading.get_product = false
      }
    },

    async m__get_product_performance(seller) {
      try {
        let page = 1, page_size = 20
        const start_time = this.dayjs().subtract(30, 'days').startOf('d').unix()
        const end_time = this.dayjs().startOf('d').unix()
        let product_performance_resp = await seller.get_product_performance_v3(page, page_size, start_time, end_time, 'past30days')

        const performance_list = []
        while (!this.is_destroyed && this.seller && seller && this.seller.username === seller.username &&
        product_performance_resp && product_performance_resp.data && product_performance_resp.data.result &&
        product_performance_resp.data.result.items && product_performance_resp.data.result.items.length) {
          this.loading.get_product = true

          performance_list.push(...product_performance_resp.data.result.items)
          if (performance_list.length > product_performance_resp.data.result.total) {
            break
          }

          for (const product of product_performance_resp.data.result.items) {
            const product_found = this.product_list.find(i => i.itemid === product.id)
            if (product_found) product_found.add_to_cart_units = product.add_to_cart_units
          }

          await this.sleep(1000)
          page++
          product_performance_resp = await seller.get_product_performance_v3(page, page_size, start_time, end_time, 'past30days')
        }
      } catch (e) {
      } finally {
        this.loading.get_product = false
      }
    },

    m__show_select_product_dialog() {
      this.show_dialog.select_product = true
    },

    m__select_all() {
      // this.indeterminate = false
      // if (this.is_selected_all) {
      //   this.c__product_filter_list.forEach(i => {
      //     i.selected = true
      //   })
      // } else {
      //   this.product_list.forEach(i => {
      //     i.selected = false
      //   })
      // }
      this.indeterminate = false
      if (this.is_selected_all) {
        this.product_selected_list.forEach(i => {
          i.selected = true
        })
      } else {
        this.product_selected_list.forEach(i => {
          i.selected = false
        })
      }
    },

    m__indeterminate() {
      // if (this.product_list.filter(i => i.selected === true).length === this.product_list.length) {
      //   this.is_selected_all = true
      //   this.indeterminate = false
      // } else if (this.product_list.filter(i => i.selected === true).length === 0) {
      //   this.is_selected_all = false
      //   this.indeterminate = false
      // } else {
      //   this.is_selected_all = false
      //   this.indeterminate = true
      // }
      if (this.product_selected_list.filter(i => i.selected === true).length === this.product_selected_list.length) {
        this.is_selected_all = true
        this.indeterminate = false
      } else if (this.product_selected_list.filter(i => i.selected === true).length === 0) {
        this.is_selected_all = false
        this.indeterminate = false
      } else {
        this.is_selected_all = false
        this.indeterminate = true
      }
    },

    m__product_sort_change({
                             prop,
                             order
                           }) {
      this.product_sort_option.order = order
      this.product_sort_option.prop = prop
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/agency/plan_order.vue